// extracted by mini-css-extract-plugin
module.exports = {"unresolvedComponent":"jut__UnresolvedComponent__unresolvedComponent"};